import React, { useState } from "react";
import { Box, TextInput, Group, ScrollArea, Stack, Paper, Text, ThemeIcon } from "@mantine/core";
import { FaBriefcase, FaSortAmountDownAlt, FaHistory } from "react-icons/fa";
import { Link } from "react-router-dom"; // 👈 för routing
import { useGetMultiplacerProjectsQuery } from "../openapi";
import { useAppSelector } from "./app/hooks";

export const Projects: React.FC = () => {
  const [search, setSearch] = useState("");

  const { data: projects = [], isError, isLoading } = useGetMultiplacerProjectsQuery(undefined);

  const filteredProjects = projects.filter((project) =>
    project.title.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <Box
      maw={600}
      mx="auto"
      mt="xl"
      p="md"
      bg="white"
      style={{ width: "100%", borderRadius: 8, boxShadow: "0 2px 5px rgba(0,0,0,0.1)" }}
    >
      {isError && <p>Error loading page</p>}
      <Text size="xl" fw={500} mb="sm">
        Prosjekter
      </Text>

      <Group mb="sm" justify="space-between">
        <TextInput
          placeholder="Søk..."
          value={search}
          onChange={(event) => setSearch(event.currentTarget.value)}
          style={{ flex: 1 }}
        />
        <Group gap="xs">
          <ThemeIcon variant="light" color="gray">
            <FaSortAmountDownAlt size={16} />
          </ThemeIcon>
          <ThemeIcon variant="light" color="gray">
            <FaHistory size={16} />
          </ThemeIcon>
        </Group>
      </Group>

      <ScrollArea h={350}>
        <Stack>
          {filteredProjects.map((project) => (
            <Paper
              key={project.projectNo}
              p="sm"
              withBorder
              radius="md"
              component={Link}
              to={`/${project.projectNo}/design`} // 👈 länken
              style={{ textDecoration: "none", color: "inherit" }}
            >
              <Group align="flex-start">
                <ThemeIcon variant="light" size="lg">
                  <FaBriefcase size={16} />
                </ThemeIcon>
                <Box>
                  <Text size="sm" fw={500}>
                    {project.title}
                  </Text>
                  <Text size="xs" color="dimmed">
                    {project.projectNo}
                  </Text>
                </Box>
              </Group>
            </Paper>
          ))}
        </Stack>
      </ScrollArea>
    </Box>
  );
};
